<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div v-if="isFetching" class="text-center py-4">
              <i class="fa fa-spinner fa-spin fa-2x"></i>
              <p class="mt-2">Memuat data...</p>
            </div>

            <div v-else>
              <form @submit.prevent="save">
                <div class="row">
                  <!-- Profesi -->
                  <div class="col-md-6">
                    <div class="form-group mb-3">
                      <label>Profesi</label>
                      <v-select
                        v-model="form.id_mprofesi"
                        :options="optionProfesi"
                        :reduce="(item) => item.id_mprofesi"
                        label="nama_profesi"
                        placeholder="Pilih Profesi"
                        @input="onProfesiChange"
                        @update:modelValue="onProfesiChange"
                        @search="onSearchProfesi"
                      />
                    </div>
                  </div>

                  <!-- Kompetensi -->
                  <div class="col-md-6">
                    <div class="form-group mb-3">
                      <label>
                        Kompetensi <span class="text-danger">*</span>
                      </label>
                      <v-select
                        v-model="form.idverif_kompetensi"
                        :options="optionKompetensi"
                        :reduce="(item) => item.idverif_kompetensi"
                        label="nama_kompetensi"
                        placeholder="Pilih Kompetensi"
                        @input="onKompetensiChange"
                        @update:modelValue="onKompetensiChange"
                        @search="onSearchKompetensi"
                      />
                    </div>
                  </div>

                  <!-- Level -->
                  <div class="col-md-6">
                    <div class="form-group mb-3">
                      <label
                        >Level Proficiency
                        <span class="text-danger">*</span></label
                      >
                      <v-select
                        v-model="form.idlevel_kompetensi"
                        :options="optionLevel"
                        :reduce="(item) => item.idlevel_kompetensi"
                        label="nama_level"
                        placeholder="Pilih Level"
                        @search="onSearchLevel"
                      />
                    </div>
                  </div>

                  <!-- Definisi (Auto Fill) -->
                  <div class="col-md-6">
                    <div class="form-group mb-3">
                      <label>Definisi</label>
                      <input
                        v-model="form.definisi"
                        type="text"
                        class="form-control"
                        placeholder="Definisi Kompetensi"
                        readonly
                      />
                    </div>
                  </div>

                  <!-- Perilaku -->
                  <div class="col-md-12">
                    <div class="form-group mb-3">
                      <label>Deskripsi Perilaku</label>
                      <textarea
                        v-model="form.perilaku"
                        class="form-control"
                        rows="3"
                        placeholder="Masukkan Deskripsi Perilaku"
                      ></textarea>
                    </div>
                  </div>
                </div>

                <hr />

                <div class="row">
                  <!-- Judul Diklat -->
                  <div class="col-md-12">
                    <div class="form-group mb-3">
                      <label>Judul Diklat</label>
                      <table class="table table-bordered table-sm">
                        <!-- <thead class="table-light">
                          <tr>
                            <th>Judul Diklat</th>
                            <th width="50" class="text-center">Aksi</th>
                          </tr>
                        </thead> -->
                        <tbody>
                          <tr
                            v-for="(item, index) in form.diklat"
                            :key="'diklat-' + index"
                          >
                            <td>
                              <v-select
                                v-model="
                                  form.diklat[index].idverif_judul_diklat
                                "
                                :options="optionDiklat"
                                :reduce="(opt) => opt.idverif_judul_diklat"
                                label="nama_diklat"
                                placeholder="Cari Judul Diklat"
                                @search="onSearchDiklat"
                              />
                            </td>
                            <td class="text-center" width="50">
                              <button
                                type="button"
                                class="btn btn-danger btn-sm"
                                @click="removeDiklat(index)"
                              >
                                <i class="fa fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="2">
                              <div class="d-grid">
                                <button
                                  type="button"
                                  class="btn btn-primary btn-sm"
                                  @click="addDiklat"
                                >
                                  <i class="fa fa-plus me-1"></i> Tambah Judul
                                  Diklat
                                </button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <!-- Objektif -->
                  <div class="col-md-12">
                    <div class="form-group mb-3">
                      <label>Asesmen Objektif</label>
                      <table class="table table-bordered table-sm">
                        <tbody>
                          <tr
                            v-for="(item, index) in form.objektif"
                            :key="'objektif-' + index"
                          >
                            <td>
                              <v-select
                                v-model="
                                  form.objektif[index].idverif_asesmen_objektif
                                "
                                :options="optionAsesmenObjektif"
                                :reduce="(opt) => opt.idverif_asesmen_objektif"
                                label="label"
                                placeholder="Pilih Asesmen Objektif"
                                @search="onSearchAsesmenObjektif"
                              >
                              </v-select>
                            </td>
                            <td class="text-center" width="50">
                              <button
                                type="button"
                                class="btn btn-danger btn-sm"
                                @click="removeObjektif(index)"
                              >
                                <i class="fa fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div class="d-grid">
                                <button
                                  type="button"
                                  class="btn btn-primary btn-sm"
                                  @click="addObjektif"
                                >
                                  <i class="fa fa-plus me-1"></i> Tambah
                                  Objektif
                                </button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <!-- Action Buttons -->
                <div class="text-end mt-4">
                  <button
                    type="button"
                    class="btn btn-light me-1"
                    @click="onClose"
                  >
                    Batal
                  </button>
                  <button
                    type="submit"
                    class="btn btn-success"
                    :disabled="isLoading"
                  >
                    <span v-if="isLoading">
                      <i class="fa fa-spinner fa-spin me-1"></i> Menyimpan...
                    </span>
                    <span v-else>Simpan</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import _ from "lodash";
import Swal from "sweetalert2";

export default {
  name: "FormKompetensiLevel",
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: this.$route.params.id
        ? "Edit Kompetensi Level"
        : "Tambah Kompetensi Level",
      items: [
        { text: "Verifikasi", href: "/" },
        {
          text: "Kompetensi Level",
          href: "/master-verifikasi/kompetensi-level",
        },
        { text: this.$route.params.id ? "Edit" : "Tambah", active: true },
      ],
      isLoading: false,
      isFetching: false,
      selected_id: this.$route.params.id || null,
      form: {
        id_mprofesi: null,
        idverif_kompetensi: null,
        idlevel_kompetensi: null,
        definisi: "",
        perilaku: "",
        diklat: [],
        objektif: [],
      },
      optionProfesi: [],
      optionKompetensi: [],
      optionLevel: [],
      optionDiklat: [],
      optionAsesmenObjektif: [],
    };
  },

  mounted() {
    this.fetchProfesi();
    this.fetchLevel();
    this.fetchDiklat();
    this.fetchAsesmenObjektif();

    if (this.selected_id) {
      this.fetchDetail(this.selected_id);
    }
  },

  methods: {
    async fetchProfesi(search = "") {
      try {
        const response = await axios.get(
          process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/profesi/all",
          {
            params: { search, limit: 100 },
            headers: { Authorization: `Bearer ${localStorage.access_token}` },
          },
        );
        const resData = response.data.data;
        this.optionProfesi = Array.isArray(resData)
          ? resData
          : resData?.data || [];
      } catch (e) {
        console.error(e);
        this.optionProfesi = [];
      }
    },

    async fetchKompetensi(search = "", id_mprofesi = null) {
      // if (!id_mprofesi && !this.form.id_mprofesi) {
      //   this.optionKompetensi = [];
      //   return;
      // }
      try {
        const response = await axios.get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "referensi/verif-kompetensi/all",
          {
            params: {
              search,
              id_mprofesi: id_mprofesi || this.form.id_mprofesi,
              limit: 100,
            },
            headers: { Authorization: `Bearer ${localStorage.access_token}` },
          },
        );
        const resData = response.data.data;
        this.optionKompetensi = Array.isArray(resData)
          ? resData
          : resData?.data || [];
      } catch (e) {
        console.error(e);
        this.optionKompetensi = [];
      }
    },

    async fetchLevel(search = "") {
      try {
        const response = await axios.get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "referensi/level-kompetensi/all",
          {
            params: { search, limit: 100 },
            headers: { Authorization: `Bearer ${localStorage.access_token}` },
          },
        );
        const resData = response.data.data;
        this.optionLevel = Array.isArray(resData)
          ? resData
          : resData?.data || [];
      } catch (e) {
        console.error(e);
        this.optionLevel = [];
      }
    },

    async fetchDiklat(search = "") {
      try {
        const response = await axios.get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "referensi/judul-diklat/all",
          {
            params: { search, limit: 100 },
            headers: { Authorization: `Bearer ${localStorage.access_token}` },
          },
        );
        const resData = response.data.data;
        this.optionDiklat = Array.isArray(resData)
          ? resData
          : resData?.data || [];
      } catch (e) {
        console.error(e);
        this.optionDiklat = [];
      }
    },
    async fetchAsesmenObjektif(search = "") {
      try {
        const response = await axios.get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "referensi/asesmen-objektif/all",
          {
            params: {
              search,
              limit: 100,
              kompetensi_level_id: this.selected_id,
            },
            headers: { Authorization: `Bearer ${localStorage.access_token}` },
          },
        );

        const resData = response.data.data;
        this.optionAsesmenObjektif = Array.isArray(resData)
          ? resData
          : resData?.data || [];
      } catch (e) {
        console.error(e);
        this.optionAsesmenObjektif = [];
      }
    },

    onSearchProfesi: _.debounce(function (search, loading) {
      if (search) {
        loading(true);
        this.fetchProfesi(search).finally(() => loading(false));
      }
    }, 500),

    onSearchKompetensi: _.debounce(function (search, loading) {
      if (search) {
        loading(true);
        this.fetchKompetensi(search).finally(() => loading(false));
      }
    }, 500),

    onSearchLevel: _.debounce(function (search, loading) {
      if (search) {
        loading(true);
        this.fetchLevel(search).finally(() => loading(false));
      }
    }, 500),

    onSearchDiklat: _.debounce(function (search, loading) {
      if (search) {
        loading(true);
        this.fetchDiklat(search).finally(() => loading(false));
      }
    }, 500),

    onSearchAsesmenObjektif: _.debounce(function (search, loading) {
      if (search) {
        loading(true);
        this.fetchAsesmenObjektif(search).finally(() => loading(false));
      }
    }, 500),

    onProfesiChange(val) {
      this.form.idverif_kompetensi = null;
      this.form.definisi = "";
      this.fetchKompetensi("", val);
    },

    onKompetensiChange(val) {
      if (val) {
        const selected = this.optionKompetensi.find(
          (k) => k.idverif_kompetensi === val,
        );
        console.log({ selected });
        this.form.definisi = selected ? selected.definisi : "";
      } else {
        this.form.definisi = "";
      }
    },

    async fetchDetail(id) {
      this.isFetching = true;
      try {
        const response = await axios.get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            `verifikasi/kompetensi-level/${id}`,
          {
            headers: { Authorization: `Bearer ${localStorage.access_token}` },
          },
        );
        const data = response.data.data;
        this.form = {
          id_mprofesi: data.id_mprofesi,
          idverif_kompetensi: data.kompetensi,
          idlevel_kompetensi: data.idlevel_kompetensi,
          definisi: data.definisi ?? "",
          perilaku: data.perilaku ?? "",
          diklat: data.judul_diklat ?? [],
          objektif: data.objektif ?? [],
        };

        if (this.form.id_mprofesi) {
          await this.fetchKompetensi("", this.form.id_mprofesi);
        } else {
          await this.fetchKompetensi();
        }
      } catch (error) {
        console.error(error);
        Swal.fire("Error", "Gagal memuat detail data", "error");
      } finally {
        this.isFetching = false;
      }
    },

    addDiklat() {
      this.form.diklat.push({ idverif_judul_diklat: null });
    },

    removeDiklat(index) {
      this.form.diklat.splice(index, 1);
    },

    addObjektif() {
      this.form.objektif.push({ idverif_asesmen_objektif: null });
    },

    removeObjektif(index) {
      this.form.objektif.splice(index, 1);
    },

    async save() {
      this.isLoading = true;
      try {
        const url =
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "verifikasi/kompetensi-level";
        const method = this.selected_id ? "put" : "post";
        const endpoint = this.selected_id ? `${url}/${this.selected_id}` : url;
        const payload = { ...this.form };

        // normalize idverif_kompetensi
        if (payload.idverif_kompetensi?.idverif_kompetensi) {
          payload.idverif_kompetensi =
            payload.idverif_kompetensi.idverif_kompetensi;
        }

        const response = await axios({
          method,
          url: endpoint,
          data: payload,
          headers: { Authorization: `Bearer ${localStorage.access_token}` },
        });

        await Swal.fire("Berhasil", response.data.meta.message, "success");
        this.$router.push({ name: "all-kompetensi-level" });
      } catch (error) {
        console.error(error);
        let message = "Terjadi kesalahan";

        const metaMessage = error?.response?.data?.meta?.message;
        const validationErrors = error?.response?.data?.data;

        if (
          metaMessage === "Validation Failed" &&
          Array.isArray(validationErrors)
        ) {
          message = `
              <ul style="text-align:left;">
                ${validationErrors.map((err) => `<li>${err}</li>`).join("")}
              </ul>
            `;
        } else if (metaMessage) {
          message = metaMessage;
        }

        Swal.fire({
          icon: "error",
          title: "Oops...",
          html: message,
        });
      } finally {
        this.isLoading = false;
      }
    },

    onClose() {
      this.$router.push({ name: "all-kompetensi-level" });
    },

    resetForm() {
      this.form = {
        id_mprofesi: null,
        idverif_kompetensi: null,
        idlevel_kompetensi: null,
        definisi: "",
        perilaku: "",
        diklat: [],
        objektif: [],
      };
      this.optionKompetensi = [];
    },
  },
};
</script>
